(() => {
  const BTN = '[data-picker-tooltip-btn]';
  const TIP = '[data-picker-tooltip]';

  function getPair(btn) {
    const root = btn.closest('.picker__label-tooltip');
    if (!root) return null;
    const tip = root.querySelector(TIP);
    if (!tip) return null;
    return { root, btn, tip };
  }

  function closePair(pair) {
    pair.tip.hidden = true;
    pair.btn.setAttribute('aria-expanded', 'false');
  }

  function openPair(pair) {
    pair.tip.hidden = false;
    pair.btn.setAttribute('aria-expanded', 'true');
  }

  function closeAll(exceptRoot = null) {
    document.querySelectorAll(BTN).forEach((b) => {
      const pair = getPair(b);
      if (!pair) return;
      if (exceptRoot && pair.root === exceptRoot) return;
      closePair(pair);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(BTN);

    if (!btn) {
      if (e.target.closest(TIP)) return;
      closeAll();
      return;
    }

    e.preventDefault();

    const pair = getPair(btn);
    if (!pair) return;

    const willOpen = pair.tip.hidden;
    closeAll(pair.root);
    if (willOpen) openPair(pair);
    else closePair(pair);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();